export class PublicKey {
  constructor(private readonly id: number, private readonly shortDescription: string, private readonly hasPrivateKey: boolean | null) {}

  getId() {
    return this.id;
  }

  getShortDescription() {
    return this.shortDescription;
  }

  getHasPrivateKey() {
    return this.hasPrivateKey;
  }
}
